var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilTime } from "../../../utils/utilTime";
import { TextLoca } from "../text/TextLoca";
import { HOCTimer } from "../timer/HOCTimer";
var TimerCountdownWithText = /** @class */ (function (_super) {
    __extends(TimerCountdownWithText, _super);
    function TimerCountdownWithText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimerCountdownWithText.prototype.render = function () {
        var _a = this.props, remainingTime = _a.remainingTime, className = _a.className, locaId = _a.locaId;
        var time = utilTime.secondsLeftTill(remainingTime);
        var replacements = new Map([[ReplacementLoca.zero_0, utilTime.format(time)]]);
        return React.createElement(TextLoca, { className: className, id: locaId, replacements: replacements });
    };
    TimerCountdownWithText = __decorate([
        HOCTimer(false)
    ], TimerCountdownWithText);
    return TimerCountdownWithText;
}(React.Component));
export { TimerCountdownWithText };



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/timer-with-text/TimerCountdownWithText.tsx
// module id = 2632
// module chunks = 3